<div class="product-slider" *ngIf="productDetailService.productDetail$ | async as product">
    <div class="slider-content">
        <div class="splash-saving" *ngIf="!campaignSplash && product.onSale">
            <app-product-splash
                [text]="'productPrices.save' | translateSafe"
                [amount]="product.discountPercentage"
                type="save"
                size="l"
            >
            </app-product-splash>
        </div>

        <!-- we will render the campaign splash if is a member campaign and if the id exists in Umbraco -->
        <div class="splash-statement"
             *ngIf="activeCampaigns?.length && (activeCampaigns | campaignByMemberType | async) as splash">
            <app-product-splash
                [text]="splash.splashDescription"
                type="statement"
                size="xl"
                [style]="{
                    backgroundColor: splash.ribbonColor | colorStringToHex
                }"
            ></app-product-splash>
        </div>

        <!-- we don't want to show the campaign splash if is a mixed campaign and
            we will get the primary splashes information and map it to a encode splash -->
        <div class="splash-statement"
             *ngIf="!(activeCampaigns | getCampaignType: 'Mixed') && (activeSplashes | getCampaignSplash) as splash">
            <app-product-splash
                [text]="splash.splashDescription"
                type="statement"
                size="xl"
                [style]="{
                    backgroundColor: splash.ribbonColor | colorStringToHex
                }"
            ></app-product-splash>
        </div>

        <div class="splash-statement" *ngIf="(product | firstSplash | async) as splash">
            <app-product-splash
                [text]="splash.splashDescription"
                type="statement"
                size="xl"
                [style]="{
                    backgroundColor: splash.ribbonColor | colorStringToHex
                }"
            ></app-product-splash>
        </div>

        <!-- There can either be multiple images, or 1 image and video -->
        <ng-container *ngIf="product.packShot?.length as length">
            <div class="slider-buttons" *ngIf="length > 1 || (length === 1 && product.youtube)">
                <button
                    class="kk-slider-button slider-button button-previous"
                    (click)="slider.previous()"
                    [ngClass]="{ 'button-faded': !slider.pagingLeftPossible }"
                >
                    <span class="arrow kk-float-horizontally-left">
                        <app-svg-icon aria-hidden="true" iconName="chevron_left"></app-svg-icon>
                    </span>
                    <span class="kk-visuallyhidden"> {{ 'general.action.next' | translateSafe }}</span>
                </button>
                <button
                    class="kk-slider-button slider-button button-next"
                    (click)="slider.next()"
                    [ngClass]="{ 'button-faded': !slider.pagingRightPossible }"
                >
                    <span class="arrow kk-float-horizontally-right">
                        <app-svg-icon aria-hidden="true" iconName="chevron_right"> </app-svg-icon>
                    </span>
                    <span class="kk-visuallyhidden">{{ 'general.action.previous' | translateSafe }}</span>
                </button>
            </div>
        </ng-container>

        <div class="slider-container">
            <app-slider #slider [scrollByItems]="1" [style]="{ height: '100%' }">
                <ng-container *ngIf="product.packShot as images">
                    <ng-container *ngFor="let image of images; let i = index">
                        <div class="slider-item" *ngIf="image.url">
                            <div class="slider-item-inner">
                                <app-image
                                    *ngIf="(breakpointServiceMin.breakpoint$ | async)?.isMobile"
                                    class="image"
                                    [image]="{ src: image.url, name: product.productName }"
                                    [width]="0"
                                    [height]="400"
                                    [style]="{ height: '100%', objectFit: 'contain' }"
                                    [index]="i"
                                    [indexLoadingThreshold]="1"
                                ></app-image>
                                <app-image
                                    *ngIf="!(breakpointServiceMin.breakpoint$ | async)?.isMobile"
                                    class="image"
                                    [image]="{ src: image.url, name: product.productName }"
                                    [width]="0"
                                    [height]="800"
                                    [style]="{ height: '100%', objectFit: 'contain' }"
                                    [index]="i"
                                    [indexLoadingThreshold]="1"
                                ></app-image>
                            </div>
                        </div>
                    </ng-container>
                </ng-container>

                <!-- For youtube videos we use the ID from the youtube field on the product -->
                @if ((product.youtube | multipleVideos); as videos) {
                    @for (video of videos; let i = $index; track i) {
                        <div class="slider-item">
                            <div class="slider-item-inner">
                                <div class="slider-video-wrapper">
                                    <div class="slider-video">
                                        <app-video-player [videoUrl]="video" [muted]="true"></app-video-player>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                }
            </app-slider>
        </div>
    </div>

    <div class="thumbnails" *ngIf="!(breakpointServiceMin.breakpoint$ | async)?.isMobile">
        <ng-container *ngFor="let image of product.packShot; let i = index">
            <button
                class="thumbnail"
                [ngClass]="{ 'active-thumbnail': i === slider.activePage }"
                *ngIf="image.url"
                (click)="slider.goToPage(slider.pages[i], i)"
            >
                <app-product-image
                    [image]="{ src: image.url, name: product.productName }"
                    [width]="46"
                    [height]="46"
                    preset="94|94"
                    preset2x="150|150"
                ></app-product-image>
            </button>
        </ng-container>

        <!-- Video thumbnail -->
        @if ((product.youtube | multipleVideos); as videos) {
            @for (video of videos; let i = $index; let count = $count; track i) {
                <button
                    class="thumbnail video-thumbnail"
                    [ngClass]="{ 'active-thumbnail': slider.pages.length - ((count - i)) === slider.activePage }"
                    (click)="slider.goToPage(slider.pages[slider.pages.length - ((count - i))], slider.pages.length)"
                >
                    <app-svg-icon iconName="play" class="play-icon"></app-svg-icon>
                </button>
            }
        }
    </div>
</div>
